export const normalizeAssistantStatus = ({ status }: { status: string }) =>
  status.trim().toLowerCase();
